'use strict';

var util = require('./util');

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}



//////////////////
// WEBPACK FOOTER
// ./~/har-validator/~/ajv/lib/compile/schema_obj.js
// module id = 120
// module chunks = 0